
import TitleBox from '@/components/CSS/TitleBox'
import TimeCountdown from '@/components/TimeCountdown'
const setPayPassword = () => import('@/pages/account/setPayPassword')
const NumberVerify = () => import('@/components/NumberVerify')
const QrPay = () => import('@/components/QrPay')
import { mapGetters } from 'vuex'
import { sleep, toMoney } from '@/utils/validate'
import md5 from 'js-md5'
export default {
    components: {
        setPayPassword,
        TimeCountdown,
        NumberVerify,
        QrPay,
        TitleBox
    },
    computed: {
        // ...mapGetters(['payInfo', 'userAccount']),
        ...mapGetters({
            payInfo: 'game/payInfo',
            userAccount: 'user/userAccount'
        })
    },
    data() {
        return {
            notCheckBalanceAmount: false,
            payTimeEnd: false,
            fullscreenLoading: false,
            orderTime: null,
            setPassForm: {
                payPass: '',
                payRePass: '',
                code: ''
            },
            setPassRules: [],
            centerPayDialogVisible: false,
            centerPayQRDialogVisible: false,
            submitLoading: false,
            submitPayLoading: false,
            dialogVisible: false,
            dialogVisibleSetPass: false,
            timers: '',
            paymentWayIndex: 'alipay'
        }
    },
    methods: {
        paySuccess(payStatus, msg = '支付失败') {
            if (payStatus === 'PAY_SUCCESS') {
                this.$message.success('支付成功，请完成您的联系方式！')
                // this.$store.commit('game/SET_PAY_INFO', {})
                // this.$router.push('/account/bargainMe')
                this.$router.push(`/confirmOrder/contactInfo?goodsNo=${this.$route.query.goodsNo}&goodsCatalogueId=${this.$route.query.goodsCatalogueId}&gameName=${this.$route.query.gameName}`)
            } else {
                this.$message.error(msg)
                this.centerPayDialogVisible = false
            }
        },
        closePayDialogOkVisible() {
            this.centerPayQRDialogVisible = false
            this.centerPayDialogVisible = false
            // if (!this.$refs["qrPay"]) return;
            this.$refs['qrPay'].closeDialogVisible()
        },
        closePayDialogVisible(done) {
            this.centerPayQRDialogVisible = true
            if (!this.centerPayQRDialogVisible) {
                done()
            }
            // if (!this.$refs["qrPay"]) return;
            // this.$refs["qrPay"].closeDialogVisible();
        },
        toMoneyPrice(num) {
            return toMoney(num)
        },
        submitForm() {
            this.submitPayLoading = true
            if (this.paymentWayIndex === 'alipay') {
                sleep(800)
                    .then(() => {
                        this.submitPayLoading = false
                        this.centerPayDialogVisible = true
                    })
                    .then(() => {
                        this.$refs['qrPay'].getPayqrCodeUrl()
                    })
                return
            }
            // 查询用户余额够不够
            this.$store.dispatch('user/UserCenterStatistics').then((res) => {
                this.submitPayLoading = false
                let data = res.data
                if (parseFloat(data.balanceAmount) < parseFloat(this.payInfo.attentionMoney)) {
                    this.$confirm('尊敬的盼之用户，您好：你的钱包余额不足，请前往账户进行充值。', '余额不足', {
                        confirmButtonText: '立即前往',
                        type: 'error'
                    })
                        .then(() => {
                            this.$router.push('/account/addMoney?toPay=true')
                        })
                        .catch(() => {})
                } else {
                    // 查看用户有没有设置支付密码
                    this.checkUserSetPass()
                }
            })
            // this.dialogVisible = true;
            // this.dialogVisibleSetPass = true;
        },
        /** 查看用户有没有设置支付密码 **/
        checkUserSetPass() {
            this.$store.dispatch('user/UserCheckAccountWhetherSetPayPass').then((res) => {
                if (!res.data) {
                    this.dialogVisibleSetPass = true
                    return
                }
                // 设置了支付密码就弹出支付
                this.dialogVisible = true
            })
        },
        /** 设置支付密码回调 **/
        setPassHandler() {
            this.checkUserSetPass()
        },
        completed(v) {
            if (v.length === this.$enum.payPassLength) {
                this.fullscreenLoading = true
                let p = {
                    action: {
                        id: this.payInfo.id,
                        payPassword: md5(v),
                        payScene: 'QR_CODE',
                        payType: 'BALANCE'
                    }
                }
                this.$api.bargainPay(p).then((res) => {
                    this.fullscreenLoading = false
                    if (!res.success) {
                        this.$message.error(res.info)
                        return
                    }
                    this.paySuccess('PAY_SUCCESS')
                })
            }
        },
        changePaymentWay(type) {
            if (this.notCheckBalanceAmount) {
                return
            }
            this.paymentWayIndex = type
        },
        /** 支付剩余时间结束 **/
        countDownEnd() {
            this.payTimeEnd = true
        },
        back() {
            this.$router.go(-1)
            this.$store.commit('game/SET_PAY_INFO', {})
        }
    },
    created() {
        console.log(this.payInfo, 'this.payInfo~~~~')
        // 精确的订单剩余秒数时间
        // const ct = new Date(this.payInfo.createTime).getTime()
        // const st = new Date().getTime()
        // this.orderTime = (this.payInfo.timeout * 1000 - (st - ct)) / 1000
        // const createTime = this.payInfo.createTime
        // const nowTime = this.payInfo.nowTime
        // const ct = new Date(createTime).getTime()
        // const st =nowTime? new Date(nowTime).getTime():new Date().getTime()
        // const t = st - ct
        // this.orderTime = (15 * 60 * 1000 - t) / 1000
        this.orderTime = this.payInfo.timeout
        // 从我的砍价过来如果超时了
        if (this.orderTime <= 0) this.countDownEnd()
        this.$store.dispatch('user/UserCenterStatistics').then(() => {
            // 如果用户余额小于意向金，余额支付就不允许选中
            this.notCheckBalanceAmount = this.userAccount.balanceAmount < this.payInfo.attentionMoney
        })
    },
    destroyed() {
        this.closePayDialogVisible()
    }
}
